import React from 'react';
import './App.css';
import {BrowserRouter, Routes, Route } from "react-router-dom";
import NginxConfListPage from "./pages/ConfListPage";
import NginxConfEditPage from "./pages/ConfEditPage";
import 'antd/dist/reset.css';
import {Bounce, ToastContainer} from "react-toastify";
import {IS_TEST} from "./utils/config";
import ServiceListPage from "./pages/ServiceListPage";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage/>} />
                <Route path="/conf/list" element={<NginxConfListPage/>} />
                <Route path="/conf/edit/:domainName" element={<NginxConfEditPage/>} />
                <Route path="/service/list" element={<ServiceListPage/>} />
            </Routes>
        </BrowserRouter>
        <ToastContainer
            position="top-center"
            autoClose={2000}
            closeButton={false}
            hideProgressBar={true}
            newestOnTop={false}
            rtl={false}
            pauseOnFocusLoss={IS_TEST}
            pauseOnHover
            theme="light"
            transition={Bounce}
        />
    </div>
  );
}

export default App;
